/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * VAT validation status
 * @export
 */
export const VatStatus = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Unchecked: 'UNCHECKED'
} as const;
export type VatStatus = typeof VatStatus[keyof typeof VatStatus];


export function instanceOfVatStatus(value: any): boolean {
    for (const key in VatStatus) {
        if (Object.prototype.hasOwnProperty.call(VatStatus, key)) {
            // @ts-ignore
            if (VatStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VatStatusFromJSON(json: any): VatStatus {
    return VatStatusFromJSONTyped(json, false);
}

export function VatStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VatStatus {
    return json as VatStatus;
}

export function VatStatusToJSON(value?: VatStatus | null): any {
    return value as any;
}

